<template>
  <div>
      <van-nav-bar
        :left-text="leftText"
        left-arrow
        @click-left="onClickLeft"
        :border="false"
        />
  </div>
</template>

<script>
export default {
    name: 'navbarSimple',
    props: {
        leftText: String
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        }
    }
}
</script>

<style>

</style>